import React from 'react';
import { useSelector } from 'react-redux';
import { Heading, Paragraph } from '@zillow/constellation';

import UnsubscribeError from 'app/shared/components/UnsubscribeError';

import * as S from './styles';

import type { State } from 'app/shared/types/State';

const UnsubscribeAllPage = () => {
  const didUnsubscribeAllSucceed = useSelector((state: State) => state.marketing.didUnsubscribeAllSucceed);

  return (
    <S.Page>
      <S.Content>
        {didUnsubscribeAllSucceed ? (
          <>
            <Heading level={2} as="h1" marginTop="lg" fontFamily="serif">
              Thank you!
            </Heading>
            <Paragraph as="h3" marginTop="md">
              You&apos;ve been unsubscribed from all market update emails.
            </Paragraph>
          </>
        ) : (
          <UnsubscribeError />
        )}
      </S.Content>
    </S.Page>
  );
};

export default UnsubscribeAllPage;
